<template>
    <div class="polon-element row">
        <b-col cols="5" style="margin: auto">
            <span class="filename">{{ element.filename }}</span>
        </b-col>
        <b-col cols="1" style="margin: auto">
          <pcg-checkbox variant="normal" v-model="element.addEmployee" @input="changeAddEmployee" v-if="element.state === 'loaded'">
            <span class="filename">{{ tf(element.addEmployee) }}</span>
          </pcg-checkbox>
          <span v-else class="filename">{{ tf(element.addEmployee) }}</span>
        </b-col>
        <b-col cols="3" style="margin: auto">
            <span class="date">{{ $d(Date.parse(element.createdAt), 'longDate') }}</span>
        </b-col>
        <b-col cols="3" class="d-flex justify-content-end">
            <pcg-btn v-if="element.state === 'loaded'" @click="parseFile" :disabled="xmlSpinner">
                {{ $t('components.polon_element.import') }}
                <spinner v-if="xmlSpinner"/>
                <span v-if="element.textStatus">({{ element.textStatus }})</span>
            </pcg-btn>
            <pcg-btn @click="deleteXml" class="btn-danger" :disabled="xmlSpinner">{{ $t('components.polon_element.delete') }}</pcg-btn>
        </b-col>
    </div>
</template>

<script>
import waitForJobs from '../mixins/wait_for_jobs'
import unexpectedError from '../mixins/unexpected_error'
import tf from '../mixins/tf'
import Spinner from './Spinner'
import ApiPbn from '../api/pbn'

export default {
  name: 'PolonElement',
  components: { Spinner },
  mixins: [tf, unexpectedError, waitForJobs],
  data: function () {
    return {
      xmlSpinner: false,
      jid: ''
    }
  },
  props: {
    element: Object
  },
  watch: {
    jid (newValue) {
      if (newValue !== null) {
        this.xmlSpinner = true
        this.waitForJob(this.jid, this.xmlParsed, this.unexpectedError)
      }
    }
  },
  created () {
    this.jid = this.element.jid
  },
  methods: {
    xmlUpdate () {
      this.$emit('updated', this.element.id)
    },
    parseFile () {
      ApiPbn.parseXmlFile(this.element.id)
        .then(result => {
          const jobId = result.data.jobId
          if (jobId !== undefined) {
            this.xmlSpinner = true
            this.waitForJob(jobId, this.xmlParsed, this.unexpectedError)
          }
        })
        .catch(error => {
          this.unexpectedError()
          console.log(error)
        })
    },
    xmlParsed () {
      this.xmlUpdate()
      this.xmlSpinner = false
    },
    deleteXml () {
      ApiPbn.deleteXml(this.element.id)
        .then(result => {
          this.$emit('deleted')
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeAddEmployee () {
      ApiPbn.updateAddEmployee(this.element.id, this.element.addEmployee)
        .then(result => {
          // do nothing
        })
        .catch(error => {
          this.unexpectedError()
          console.log(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
    @import '../assets/stylesheets/vars';

    .btn-danger {
        color: #fff;
        background-color: #dc3545;
        border-color: #dc3545;

        &:hover {
            color: #fff;
            background-color: #c82333;
            border-color: #bd2130;
        }
    }

    .filename {
        color: $pcg-gray;
        font-weight: 400;
    }

    .date {
        color: $pcg-gray;
        font-weight: 400;
    }

    /deep/ .pcg-checkbox-container {
      margin-right: 0;
      margin-bottom: 0;
    }
</style>

<style lang="scss" scoped>
    @import "../assets/stylesheets/vars-contrast";
    .contrast {
        .btn-danger {
            color: #fff;
            background-color: #dc3545;
            border-color: #dc3545;
            &:hover {
                color: #fff;
                background-color: #c82333;
                border-color: #bd2130;
            }
        }
        .filename {
            color: $pcg-gray;
        }
        .date {
            color: $pcg-gray;
        }
        /deep/ .pcg-checkbox-container {
          margin-right: 0;
          margin-bottom: 0;
        }
    }
</style>
